<template>
  <div class="page-content">
    <div class="page-main-content">
      <div class="container-fluid">
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
              :to="`/admin/locations/${item.id}/edit`"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <div>
                    {{ item.description }}
                  </div>
                </v-list-item-title>
                <v-list-item-subtitle>{{
                  item.brand_description
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <div class="row">
          <bx-box
            :title="totalLocations + ' ' + $t('lang.admin.list_of_locations')"
            color="white"
            no-padding
            class="col-12"
            :loading="shouldLoading"
          >
            <template v-slot:default>
              <skeleton-table :columns="3" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="totalLocations"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered>{{
                    props.row.description
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.brand_description
                  }}</bx-table-column>
                  <bx-table-column centered>
                    <router-link
                      :to="`/admin/locations/${props.row.id}/edit`"
                      class="bx-link bx-link-bold"
                      >Edit</router-link
                    >
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AreasList",
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      totalLocations: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      let locations = await this.$api.location.listLocations({
        offset: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage
      });
      this.data = locations.results;
      this.totalLocations = locations.count;
      this.columns = [
        {
          field: "Description",
          label: this.$t("lang.admin.label_description"),
          centered: true
        },
        {
          field: "description",
          label: this.$t("lang.admin.label_brand"),
          centered: true
        },
        {
          field: "",
          label: this.$t("lang.admin.label_action"),
          centered: true
        }
      ];

      this.shouldLoading = false;
    }
  }
};
</script>

<style></style>
